module.exports = __webpack_public_path__ + "img/2.0cc97753.png";